// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"a150130d","864":"ae1c3688"}[chunkId] + ".chunk.js";
};